<div class="vcc-daily-summary-container">
  <div *ngIf="isLoaded" class="content-area">
    <div class="grid-title-event">
      <h2 data-testid="vcc-summary-report-list-title">VCC Daily Summary Report</h2>

      <div class="events-container">
          @if(!isError && dataSource.filteredData.length){
              <button  data-testid="vcc-summary-report-refresh-button" aria-label="Refresh grid"  mat-icon-button (click)="getVccDailySummaryReport()">
                  <mat-icon fontIcon="replay"></mat-icon>
              </button>
              <button color="primary" data-testid="download-vcc-summary-report-button" aria-label="Download Adx Vcc File" mat-stroked-button (click)="downloadGridToFile()" class="btn-download">
                  <mat-icon>download</mat-icon>
              </button>
          }
      </div>
    </div>

    <div *ngIf="!isError" class="data-content">
      <div *ngFor="let field of objectFields">
        <mat-list>
          <mat-list-item class="data-row">
            <span class="data-key">{{ field.displayName }} : </span>
            <span>
              <mat-chip class="data-value" highlighted color="primary" >{{ dataSource.data[0][field.key]}}</mat-chip>
            </span>
          </mat-list-item>
          <mat-divider></mat-divider>
        </mat-list>
      </div>
    </div>

    <div *ngIf="isError" class="error-container">
      <mat-icon>info</mat-icon>
      <span>No results found with the current filters.</span>
    </div>

    <div *ngIf="!isError && (!dataSource || !dataSource.data || dataSource.data.length === 0)" class="no-data-container">
      <mat-icon>info</mat-icon>
      <span>There are no records to display.</span>
    </div>
  </div>
</div>
